import Box from '@mui/material/Box'

function StatRow({ label, value }) {
  return (
    <Box display="flex" justifyContent="space-between">
      <div>{label}:</div>
      <Box marginLeft={2}>{value}</Box>
    </Box>
  )
}

export default StatRow
